import { clsx } from 'clsx';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import {
  voltZeroBubbleTail,
  voltZeroBuildHistory,
} from '@/assets/images/offer/volt-zero';
import styles from './VoltZeroBanner.module.scss';

interface VoltZeroBannerProps {
  trackingId: string;
  onClick: () => void;
}

const POINTS = [
  { label: '+12 puncte', className: styles['bubble--left'] },
  { label: '+9 puncte', className: styles['bubble--center'] },
  { label: '+7 puncte', className: styles['bubble--right'] },
];

export function VoltZeroBanner({ trackingId, onClick }: VoltZeroBannerProps) {
  return (
    <div className={styles.root}>
      <img src={voltZeroBuildHistory} alt="" className={styles.photo} />
      <p className={styles.title}>
        <span>Construiește-ți</span>
        <span>istoricul de credit</span>
      </p>
      {POINTS.map(({ label, className }) => (
        <div key={label} className={clsx(styles.bubble, className)} aria-hidden>
          <span className={styles.bubbleLabel}>
            <span className={styles.bubbleText}>{label}</span>
          </span>
          <span className={styles.bubbleTail}>
            <img src={voltZeroBubbleTail} alt="" width={93} height={3.22614} />
          </span>
        </div>
      ))}
      <Button
        trackingId={trackingId}
        variant="text"
        size="small"
        rightIcon={<Icon name="arrow-right" size={16} />}
        onClick={onClick}
        className={styles.button}
      >
        Află detalii
      </Button>
    </div>
  );
}
